import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

import { apiFetch } from '../services/api';
const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook liest den Pro-Aktivierungsstatus der aktuellen Firma.
 * Wird verwendet, um den Upgrade-Button vs. Pro-Dashboard zu entscheiden.
 */
const useProStatus = () => {
  const { company } = useAuth();
  const [status, setStatus] = useState({ active: false, plan: null, seats: 0, loading: true });

  const reload = useCallback(async () => {
    if (!company) {
      setStatus({ active: false, plan: null, seats: 0, loading: false });
      return;
    }
    try {
      const res = await apiFetch(`${API}/api/pro/status`, {
        headers: {} });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus({
          active: !!data.active,
          plan: data.plan,
          seats: data.seats,
          renewsAt: data.renewsAt,
          loading: false });
      } else {
        setStatus({ active: false, plan: null, seats: 0, loading: false });
      }
    } catch {
      setStatus({ active: false, plan: null, seats: 0, loading: false });
    }
  }, [company]);

  useEffect(() => { reload(); }, [reload]);

  return { ...status, reload };
};

export default useProStatus;
